<template lang="html">
  <v-modal
    :name="name"
    :show="show"
    @onHide="onHide"
    v-if="name === 'description-text'"
    :size="4"
  >
    <v-inner :size="0">
      <div style="padding: 15px 20px">
        <p style="word-wrap: break-word">
          {{data.descriptionText}}
        </p>
      </div>
    </v-inner>
  </v-modal>
  <!-- CAMPAING RECESSO 2022 -->
  <v-modal
    :name="name"
    :show="show"
    @onHide="onHide"
    v-else-if="name === 'recesso-2022'"
    :size="4"
  >
    <v-inner :size="0">
      <div style="padding: 15px 20px">
        <template v-if="data.vibbrante === false">
          <p>
            <strong>ATENÇÃO!</strong>
            <br><br>
            Devido ao feriado, os pagamentos que normalmente ocorreriam na segunda-feira (21/04) serão realizados na terça-feira (22/04), para resgates solicitados até segunda-feira.
            <br><br>
            📅 Os pagamentos da semana serão feitos nos dias 22/04 (terça) e 24/04 (quinta).
            <br><br>
            Fique atento(a) aos prazos e programe seu resgate com antecedência!
          </p>
        </template>
        <template v-else>
          <p>
            <strong>Olá!</strong>
            <br><br>
            Informamos que nosso atendimento estará suspenso nos dias 18 e 21/04 devido ao feriado prolongado.
            <br><br>
            Desejamos a todos um excelente feriado! 🎉
            <br><br>
            Caso precisem de algo, deixe sua mensagem que retornaremos o contato assim que possível, a partir do dia 22/04.
            <br><br>
            Agradecemos pela compreensão e até breve!
          </p>
        </template>
      </div>
    </v-inner>
  </v-modal>

  <!-- VIBBRANT PROFILE -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    v-else-if="name === 'user'"
    :size="3"
  >
    <v-inner :size="3">
      <v-vibbrant-profile :user="data.user" />
    </v-inner>
  </v-modal>

  <!-- CLIENT PROFILE -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    v-else-if="name === 'client'"
    :size="3"
  >
    <v-inner :size="3">
      <v-client-profile :user="data.user" />
    </v-inner>
  </v-modal>

  <!-- USER JUSTIFICATION -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    :size="finalized_ok ? 1 : 2"
    v-else-if="name === 'user-justification'"
  >
    <v-inner :size="3">
      <div v-if="!finalized_ok">
        <b>Motivo:</b>
        <br />
        {{ data.cancellation_reason }}
        <br />
        <b>Outras informações:</b>
        <br />
        {{ data.text }}
        <v-divider line :size="4" />
        <v-button class="link block" @click="closeByReject()"
          >Finalizar</v-button
        >
      </div>
      <div v-else>
        <v-text class="p-3">Foi movido para a lista de finalizados.</v-text>
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>

  <!-- USER FINALIZED -->
  <v-modal
    :name="name"
    title="Finalizado"
    :show="show"
    @onHide="onHide"
    :size="1"
    v-else-if="name === 'finalized'"
  >
    <v-inner :size="3">
      <v-text class="p-3">Foi movido para a lista de finalizados.</v-text>
      <v-button class="block primary" @click="hide()">Fechar</v-button>
    </v-inner>
  </v-modal>

  <!-- USER QUESTION -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    :size="2"
    v-else-if="name === 'user-question'"
  >
    <v-inner v-if="!question_ok" :size="3">
      <v-input type="textarea" rows="5" v-model="contract_comment_description"
        >Digite aqui sua dúvida</v-input
      >
      <v-button class="primary block" @click="createContractComment()"
        >Enviar</v-button
      >
      <v-divider line :size="4" />
      <v-text class="mb-1  " v-if="data.comments.length > 0">Mensagens</v-text>
      <v-list class="list-chat">
        <v-text tag="li" v-for="comment in data.comments">
          <v-div v-if="data.comment_from != comment.from"
            ><strong>{{ comment.description }}</strong></v-div
          >
          <v-div v-else>{{ comment.description }}</v-div>
          <small>
            <span v-if="data.comment_from == comment.from">
              Você
            </span>
            <span v-else-if="comment.from === 'client'">
              {{ comment.client_name }}
            </span>
            <span v-else-if="comment.from === 'vibbrante'">
              {{ comment.vibbrante_name }}
            </span>
            <span v-else>
              Equipe Vibbra
            </span>
            - {{ comment.created_at | moment('DD/MM/YYYY HH:mm') }}
          </small>
        </v-text>
      </v-list>
    </v-inner>
    <v-inner :size="3" v-else>
      <v-text class="p-3"
        >Dúvida recebida! Iremos revisar e em breve será liberada.</v-text
      >
      <v-button class="block primary" @click="hide()">Fechar</v-button>
    </v-inner>
  </v-modal>

  <!-- CLIENT CANCEL CONTRACT -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
    v-else-if="name === 'client-cancel-contract'"
  >
    <v-inner :size="3">
      <v-input
        type="textarea"
        rows="5"
        v-model="data.contract.reject_description"
        >Informe o motivo para que possamos avisar o profissional.</v-input
      >
      <v-row :size="2">
        <v-col :md="6">
          <v-button class="primary block" @click="clientRejetcContract()"
            >Confirmar</v-button
          >
        </v-col>
        <v-col :md="6">
          <v-button class="gray block" @click="hide()">Agora não</v-button>
        </v-col>
      </v-row>
    </v-inner>
  </v-modal>

  <!-- VIBBRANTE CANCEL CONTRACT -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
    v-else-if="name === 'vibbrante-cancel-contract'"
  >
    <v-inner :size="3">
      <v-input
        type="textarea"
        rows="5"
        v-model="data.contract.reject_description"
        >Digite aqui o seu motivo.</v-input
      >
      <v-row :size="2">
        <v-col :md="6">
          <v-button class="primary block" @click="vibbranteRejetcContract()"
            >Confirmar</v-button
          >
        </v-col>
        <v-col :md="6">
          <v-button class="gray block" @click="hide()">Agora não</v-button>
        </v-col>
      </v-row>
    </v-inner>
  </v-modal>

  <!-- WALLET ADD CREDIT -->
  <v-modal
    :name="name"
    title="Comprar créditos"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
    v-else-if="name === 'wallet-add-credit'"
  >
    <v-inner :size="3" v-if="!action_success">
      <v-alert>
        Em breve estaremos automatizando a compra de créditos com um meio de
        pagamento online. Por hora, nossa equipe financeira irá receber o seu
        pedido e entrar em contato com você.
      </v-alert>
      <p>
        Informe quantas horas deseja liberar de cada profissional que calculamos
        os créditos pra você.
      </p>
      <v-list>
        <v-item
          v-for="contract in data.actives_contracts"
          tag="li"
          class="d-flex justify-content-between align-items-center"
        >
          <span class=""
            ><strong>{{ contract.vibbrante.name }}</strong>
            <small>({{ contract.hour_value | currency }} / hora)</small>
          </span>
          <input
            @keyup="setBuyHours(contract, $event)"
            type="number"
            placeholder="Horas"
            class="m-0 form-control"
            style="width:120px;max-width: 180px;"
            v-model="contract.buy_hours"
          ></input>
          <div class="input-group-prepend">
            <span class="input-group-text">{{
              calcSubTotal(contract.hour_value, contract.buy_hours) | currency
 }}</span>
          </div>
        </v-item>
      </v-list>
      <v-divider line class="my-3">
        Total a pagar:&nbsp;<b> {{ calcTotal() | currency }} </b>
      </v-divider>
      <v-button class="primary block" @click="buyHours()"
        >Solicitar compra de créditos</v-button
      >
    </v-inner>
    <v-inner :size="3" v-else>
      <v-text
        >Recebemos a sua solicitação e em breve nossa equipe financeira irá
        entrar em contato com você. Obrigado!</v-text
      >
      <v-button class="block primary" @click="hide()">OK</v-button>
    </v-inner>
  </v-modal>

  <!-- CONTRACT FINALIZE -->
  <v-modal
    :name="name"
    :title="'Avaliação do cliente ' + data.client_name"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'contract-finalize'"
  >
    <v-inner v-if="!action_success">
      <p>
        Nos ajude a entender se os clientes estão cumprindo o seu papel ao
        contratar os nossos profissionais, avaliando os pontos abaixo.
      </p>
      <v-rate
        mode="input"
        v-model="data.contract.rating_management"
        :refresh="refresh"
        >Satisfação com a gestão do cliente</v-rate
      >
      <v-rate
        mode="input"
        v-model="data.contract.rating_availability"
        :refresh="refresh"
        >Satisfação com disponibilidade do cliente</v-rate
      >
      <v-rate
        mode="input"
        v-model="data.contract.rating_interest_new_job"
        :refresh="refresh"
        >Interesse em trabalhar com esse cliente novamente</v-rate
      >
      <v-input
        type="textarea"
        v-model="data.contract.rating_client_comment"
        rows="5"
        >Fique a vontade caso queira nos dizer mais alguma coisa sobre esse
        cliente.</v-input
      >
      <v-button class="block primary" @click="saveContractRatingVibbrante()"
        >Enviar</v-button
      >
    </v-inner>
    <v-inner v-else>
      <v-text class="p-3">Avaliação recebida, obrigado!</v-text>
      <v-button class="block primary" @click="hide()">Fechar</v-button>
      <p></p>
    </v-inner>
  </v-modal>

  <!-- CONTRACT FINALIZE VIBBRANT -->
  <v-modal
    :name="name"
    :title="'Avaliação do profissional ' + data.vibbrante_name"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'contract-finalize-vibbrant'"
  >
    <v-inner v-if="!action_success">
      <p>
        Nos ajude a melhorar a qualidade da nossa rede avaliando os pontos
        abaixo do profissional contratado.
      </p>
      <v-rate
        mode="input"
        v-model="data.contract.rating_quality"
        :refresh="refresh"
        >Satisfação com a qualidade do trabalho realizado</v-rate
      >
      <v-rate
        mode="input"
        v-model="data.contract.rating_professionalism"
        :refresh="refresh"
        >Satisfação com o profissionalismo</v-rate
      >
      <v-rate
        mode="input"
        v-model="data.contract.rating_recommendation"
        :refresh="refresh"
        >Interesse de contratar esse profissional novamente</v-rate
      >
      <v-input type="textarea" v-model="data.contract.rating_comment" rows="5"
        >Fique a vontade caso queira nos dizer mais alguma coisa.</v-input
      >
      <v-button class="block primary" @click="saveContractRating()"
        >Enviar</v-button
      >
    </v-inner>
    <v-inner v-else>
      <v-text class="p-3">Avaliação recebida, obrigado!</v-text>
      <v-button class="block primary" @click="hide()">Fechar</v-button>
      <p></p>
    </v-inner>
  </v-modal>

  <!-- CONTRACT NEW HOURS -->
  <v-modal
    :name="name"
    title="Contratar mais horas"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'contract-new-hours'"
  >
    <v-inner>
      <v-input type="integer" min="1" v-model="contract_new_hours_balue"
        >Informe quantas horas deseja adicionar ao contrato do
        profissional</v-input
      >
      <v-alert>
        Essas horas serão adicionadas automaticamente ao contrato atual como
        adendo, seguindo o mesmo padrão de aquisição de créditos para
        liberá-las.
      </v-alert>
      <v-button class="block primary" @click="addHoursToContract()"
        >Contratar</v-button
      >
    </v-inner>
  </v-modal>

  <!-- FEEDBACK -->
  <v-modal
    :name="name"
    title="Avaliar a plataforma Vibbra"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'feedback'"
  >
    <v-inner>
      <div v-if="!feedback_ok">
        <v-text class="pb-3"
          >Nossa evolução é constante e queremos contar com a sua ajuda! Dê o
          seu feedback sobre a nossa plataforma e nos diga o que podemos
          melhorar.</v-text
        >
        <v-rate mode="input" v-model="average_users" :refresh="refresh"
          >Satisfação com a facilidade de uso</v-rate
        >
        <v-rate mode="input" v-model="average_work" :refresh="refresh"
          >Satisfação com as funcionalidades apresentadas</v-rate
        >
        <v-rate mode="input" v-model="average_vibbra" :refresh="refresh"
          >Satisfação com o apoio da equipe Vibbra</v-rate
        >
        <v-input type="textarea" rows="5"
          >Fique a vontade para nos dizer o que mais julgar relevante para
          melhorarmos.</v-input
        >
        <v-button class="block primary" @click="feedback_ok = true"
          >Enviar</v-button
        >
      </div>
      <div v-else>
        <v-text class="p-3"
          >Obrigado por nos ajudar a melhorar a nossa plataforma!</v-text
        >
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>

  <!-- end-user-search -->
  <v-modal
    :name="name"
    title="Convites enviados!"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'end-user-search'"
  >
    <v-inner>
      <v-text class="p-3"
        >Os profissionais selecionados já foram notificados do seu interesse em
        contratá-los e terão acesso aos dados que você informou. Você poderá
        acompanhar o status desses convites na tela de Pendentes.</v-text
      >
      <v-button class="block primary" @click="hide()">OK</v-button>
    </v-inner>
  </v-modal>

  <!-- receipt -->
  <v-modal
    :name="name"
    title="Enviar nota fiscal"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
    v-else-if="name === 'receipt'"
  >
    <v-inner>
      <div v-if="!receipt_ok">
        <v-text
          >O pagamento no valor de <b>R$ 1.000,00</b> referente 2ª parcela
          parcial do projeto plataforma Vibbra está disponível.</v-text
        >
        <v-text
          >MOBILEASY TECHNOLOGIES DESENVOLVIMENTO DE PROGRAMAS DE COMPUTADOR
          EIRELI - ME</v-text
        >
        <v-text>NÚMERO DE INSCRIÇÃO: 10.906.814/0001-43</v-text>
        <v-text
          >R DELMINDA SILVEIRA, 729, BLOCO C SALA 404, CEP 88.025-500,
          FLORIANOPOLIS</v-text
        >
        <v-text>(48) 3346-9134</v-text>
        <v-input type="file"></v-input>
        <v-button class="block primary" @click="receipt_ok = true"
          >Enviar</v-button
        >
      </div>
      <div v-else>
        <v-text class="p-3">Obrigado pelo contato.</v-text>
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>

  <!-- BUG -->
  <v-modal
    :name="name"
    title="Informar um bug na plataforma"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'bug'"
  >
    <v-inner>
      <div v-if="!bug_ok">
        <v-text
          >Ops! Falhas acontecem. Mas não se preocupe que faremos o possível
          para resolver esse bug o mais breve possível. Nos informe abaixo o que
          aconteceu e se possível, qual o passo-a-passo de ações que você fez
          até ocorrer o bug.</v-text
        >
        <v-input id="bug_current_page" type="checkbox"
          >Achei o bug na página atual</v-input
        >
        <v-input type="textarea" rows="5"></v-input>
        <v-button class="block primary" @click="bug_ok = true">Enviar</v-button>
      </div>
      <div v-else>
        <v-text class="p-3"
          >Obrigado por nos ajudar a melhorar a nossa plataforma!</v-text
        >
        <v-button class="block primary" @click="hide()">Fechar</v-button>
      </div>
    </v-inner>
  </v-modal>

  <!-- HELP -->
  <!-- vibbrante_x_freelancer -->
  <v-modal
    :name="name"
    title="Diferente entre Vibbrantes e Talent Vibbra"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
    v-else-if="name === 'vibbrante_x_freelancer'"
  >
    <v-inner>
      <v-text class="p-1"
        ><b>Vibbrantes</b> são profissionais que passaram pelo nosso
        <v-link href="http://vibbra.com.br/selecao_vibbra.pdf" target="_blank"
          >processo de seleção</v-link
        >
        completo. Ou seja, analisamos em detalhes o seu perfil, testamos seus
        conhecimentos técnicos na prática e o entrevistamos. Apenas 7 em cada
        100 candidatos passam por todo o processo e se tornam Vibbrantes. São os
        melhores profissionais que você vai encontrar no mercado!</v-text
      >
      <v-text class="p-1"
        ><b>Talent Vibbra</b> são os profissionais que passaram apenas na
        primeira etapa do nosso processo, a análise de perfil. São profissionais
        com as habilidades e experiências certas para entregarem uma boa
        performance no mesmo nível dos Vibbrantes, porém, não chegaram a
        concluir todo o nosso processo e não foram testados por nós.</v-text
      >
      <v-text class="p-1">Para mais detalhes, acesse nossas FAQs.</v-text>
      <v-button class="block primary" @click="hide()">OK</v-button>
    </v-inner>
  </v-modal>

  <!-- CANCEL REQUEST -->
  <v-modal
    :name="name"
    title="Cancelar requisição"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'cancel-request'"
  >
    <v-inner>
      <v-text>Todos os dados salvos na busca serão perdidos</v-text>
      <v-divider line />
      <v-row :size="2">
        <v-col :md="6">
          <v-button class="block gray" @click="hide">Cancelar</v-button>
        </v-col>
        <v-col :md="6">
          <v-button class="block primary" @click="hide">Confirmar</v-button>
        </v-col>
      </v-row>
    </v-inner>
  </v-modal>

  <!-- ADD SKILL -->
  <v-modal
    :name="name"
    title="Editar habilidade"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'add-skill'"
  >
    <v-inner>
      <div>
        <v-input
          type="select"
          v-model="data.skill.description"
          :options="data.skills"
          >Habilidade</v-input
        >
        <v-input
          type="range"
          :interval="10"
          tooltip="hover"
          v-model="data.skill.score"
          :refresh="refresh"
          >Experiência - {{ data.skill.score }}%</v-input
        >
        <v-button class="block primary" @click="saveSkill()">Salvar</v-button>
      </div>
    </v-inner>
  </v-modal>

  <!-- ALERT-->

  <!-- ADD SKILL -->
  <v-modal
    :name="name"
    title="Assinar contrato"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="1"
    v-else-if="name === 'alert'"
  >
    <v-inner>
      <div>
        <v-text>
          {{ data.message }}
        </v-text>
        <v-button class="block primary" @click="closeAndGo(data.destiny)"
          >Ir para o perfil</v-button
        >
      </div>
    </v-inner>
  </v-modal>

  <!-- FORM COMPANY -->
  <v-modal
    :name="name"
    :title="title"
    :show="show"
    @onHide="onHide"
    @onShow="onShow"
    :size="2"
    v-else-if="name === 'form-company'"
  >
    <v-inner>
      <v-row class="size-2">
        <v-col :xs="12" :md="6">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.fantasy_name"
            >Nome fantasia</v-input
          >
        </v-col>
        <v-col :xs="12" :md="6">
          <v-input
            class="m-0"
            type="select"
            :options="[
              'Startup early stage',
              'Startup growth stage',
              'Empresa de TI',
              'Fábrica de software',
              'Agência digital',
              'Empresa não de TI',
              'Outro',
            ]"
            v-model="data.client_company.company_type"
            >Tipo de empresa</v-input
          >
        </v-col>
        <v-col :xs="12" :sm="12" :md="12">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.linkedin"
            >URL da página do LinkedIn</v-input
          >
        </v-col>
      </v-row>
      <v-row class="size-2">
        <v-col :xs="12" :md="7">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.social_name"
            v-bind:class="isRequiredPJ(data.client_company.social_name)"
            >Razão Social</v-input
          >
        </v-col>
        <v-col :xs="12" :md="5">
          <v-input
            class="m-0"
            type="cnpj"
            v-model="data.client_company.cnpj"
            v-bind:class="isRequiredPJ(data.client_company.cnpj)"
            >CNPJ</v-input
          >
        </v-col>
        <v-col :xs="12" :md="8">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.address"
            v-bind:class="isRequiredPJ(data.client_company.address)"
            >Rua</v-input
          >
        </v-col>
        <v-col :xs="12" :md="4">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.address_number"
            v-bind:class="isRequiredPJ(data.client_company.address_number)"
            >Número</v-input
          >
        </v-col>
        <v-col :xs="12" :md="4">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.address_compl"
            >Complemento</v-input
          >
        </v-col>
        <v-col :xs="12" :md="5">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.address_district"
            v-bind:class="isRequiredPJ(data.client_company.address_district)"
            >Bairro</v-input
          >
        </v-col>
        <v-col :xs="12" :md="3">
          <v-input
            class="m-0"
            type="zipcode"
            v-model="data.client_company.address_zipcode"
            v-bind:class="isRequiredPJ(data.client_company.address_zipcode)"
            >CEP</v-input
          >
        </v-col>
        <v-col :xs="12" :sm="8">
          <v-input
            type="text"
            class="m-0"
            v-model="data.client_company.address_city"
            v-bind:class="isRequiredPJ(data.client_company.address_city)"
            >Cidade</v-input
          >
        </v-col>
        <v-col :xs="12" :sm="4">
          <v-input
            type="select"
            :options="$app.data.uf"
            v-model="data.client_company.address_state"
            v-bind:class="isRequiredPJ(data.client_company.address_state)"
            class="m-0"
            >UF</v-input
          >
        </v-col>
        <v-col :xs="12" :md="6">
          <v-input
            class="m-0"
            type="text"
            v-model="data.client_company.resp_name"
            >Nome completo do responsável</v-input
          >
        </v-col>
        <v-col :xs="12" :md="6">
          <v-input class="m-0" type="cpf" v-model="data.client_company.resp_cpf"
            >CPF do responsável</v-input
          >
        </v-col>
      </v-row>
      <v-divider line />
      <div class="text-right">
        <v-button class="primary" @click="updateCompany()">Atualizar</v-button>
      </div>
    </v-inner>
  </v-modal>

  <!-- REVISE HOURS -->
</template>

<script>
import VibbrantProfile from './vibbrant-profile';
import ClientProfile from './client-profile';
import clientApi from '@/api/client';
import vibbranteApi from '@/api/vibbrante';

export default {
  components: {
    'v-vibbrant-profile': VibbrantProfile,
    'v-client-profile': ClientProfile,
  },
  props: {
    show: {
      default: false,
    },
    title: {
      default: '',
    },
    name: {
      default: 'modal',
    },
    size: {
      default: 3,
    },
    profile: {
      default: 'vibbrante',
    },
    data: {
      cancellation_reason: '',
      descriptionText: '',
    },
  },
  data() {
    return {
      errors_purchase_hours: [],
      refresh: false,
      //
      edit_profile_vibbrant_avatar_select: false,
      edit_profile_client_avatar_select: false,
      edit_profile_vibbrant_avatar_selected: 'static/avatars/0.svg',
      edit_profile_client_avatar_selected: 'static/avatars/0.svg',
      edit_profile_vibbrant_password: '',
      //
      user_value_hours: 60,
      contract_new_hours_balue: 1,

      //
      wallet_add_credit_user_1: 0,
      wallet_add_credit_user_2: 0,

      // OK vars
      feedback_ok: false,
      bug_ok: false,
      receipt_ok: false,
      money_transfer_ok: false,
      help_ok: false,
      finalized_ok: false,
      //
      range_v_FAKE: 50,
      //
      score_user: 3,
      score_work: 3,
      score_vibbra: 3,
      average_users: 3,
      average_work: 3,
      average_vibbra: 3,
      task_comment_description: '',
      contract_comment_description: '',
      question_ok: false,
      action_success: false,
    };
  },
  mounted() {
    $('input[name=repassword]').blur(() => {
      alert();
      // var pass = $('input[name=password]').val()
      // var repass = $('input[name=repassword]').val()
      // if(($('input[name=password]').val().length == 0) || ($('input[name=repassword]').val().length == 0)){
      //     $('#password').addClass('has-error')
      // }
      // else if (pass != repass) {
      //     $('#password').addClass('has-error')
      //     $('#repassword').addClass('has-error')
      // }
      // else {
      //     $('#password').removeClass().addClass('has-success')
      //     $('#repassword').removeClass().addClass('has-success')
      // }
    });
  },
  methods: {
    isRequiredPJ(value) {
      if (
        this.data.client.sign_type === 'PJ' &&
        (value === 'undefined' || value === '')
      ) {
        return 'is-invalid';
      }
      return '';
    },
    hide() {
      this.onHide();
      this.show = false;
      this.question_ok = false;
    },
    hideAndGoTo(p) {
      this.hide();
    },
    onShow() {
      this.refresh = true;
      this.$emit('onShow');
    },
    onHide() {
      this.refresh = false;
      this.$emit('onHide');

      // OK vars
      this.feedback_ok = false;
      this.bug_ok = false;
      this.money_transfer_ok = false;
      this.help_ok = false;
      this.finalized_ok = false;
      this.action_success = false;
    },
    log(v) {
      console.log(v);
    },
    closeAndGo(destiny) {
      this.hide();
      setTimeout(() => {
        this.$router.push({ name: destiny });
      }, 200);
    },
    saveContractRating() {
      this.data.contract.rating = true;
      clientApi
        .clientRatingContract(this.data.contract)
        .then(response => {
          if (response.status === 200) {
            clientApi
              .loadClosedContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadClientClosedContracts',
                    response.data
                  );
                  this.action_success = true;
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    saveContractRatingVibbrante() {
      this.data.contract.rating_client = true;
      vibbranteApi
        .vibbranteRatingContract(this.data.contract)
        .then(response => {
          if (response.status === 200) {
            vibbranteApi
              .loadClosedContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadVibbranteClosedContracts',
                    response.data
                  );
                  this.action_success = true;
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    updateProfile() {
      clientApi
        .updateProfile(this.data.client)
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientProfileData', response.data);
            this.hide();
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    updateVibbranteProfile() {
      vibbranteApi
        .updateProfile(this.data.vibbrante)
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadVibbranteProfileData', response.data);
            this.hide();
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    updateCompany() {
      clientApi
        .updateCompany(this.data.client_company)
        .then(response => {
          if (response.status === 200) {
            clientApi
              .getClientData()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch('loadClientProfileData', response.data);
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    vibbranteRejetcContract() {
      vibbranteApi
        .vibbranteRejectContract(
          this.data.contract.id,
          this.data.contract.reject_description
        )
        .then(response => {
          if (response.status === 200) {
            vibbranteApi
              .loadPendingContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadVibbranteWaitingAnswerContracts',
                    response.data
                  );
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    closeByReject() {
      if (this.profile === 'client') {
        clientApi
          .clientCloseByReject(this.data.contract.id)
          .then(response => {
            if (response.status === 200) {
              clientApi
                .loadPendingContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadClientWaitingAnswerContracts',
                      response.data
                    );
                    this.hide();
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        vibbranteApi
          .vibbranteCloseByReject(this.data.contract.id)
          .then(response => {
            if (response.status === 200) {
              vibbranteApi
                .loadPendingContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadVibbranteWaitingAnswerContracts',
                      response.data
                    );
                    this.hide();
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
    clientRejetcContract() {
      clientApi
        .clientRejectContract(
          this.data.contract.id,
          this.data.contract.reject_description
        )
        .then(response => {
          if (response.status === 200) {
            clientApi
              .loadPendingContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadClientWaitingAnswerContracts',
                    response.data
                  );
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    saveSkill() {
      vibbranteApi
        .addSkill(this.data.skill)
        .then(response => {
          vibbranteApi
            .getVibbranteData()
            .then(response => {
              if (response.status === 200) {
                this.$store.dispatch('loadVibbranteProfileData', response.data);
                this.hide();
              }
            })
            .catch(e => {
              this.$notify(e, 'error');
            });
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    calcSubTotal(value, hours) {
      if (value == undefined || hours == undefined) {
        return 0.0;
      }
      return value * hours;
    },
    calcTotal() {
      let total = 0.0;
      if (this.data.actives_contracts !== 'undefined') {
        for (let i = 0; i < this.data.actives_contracts.length; i++) {
          const buyHours = Number(this.data.actives_contracts[i].buy_hours);
          if (!isNaN(buyHours))
            total += this.data.actives_contracts[i].hour_value * buyHours;
        }
      }
      if (isNaN(total)) {
        return 0;
      }
      return total;
    },
    setBuyHours(contract, event) {
      const val = event.target.value.replace(/[^0-9]/g, "");
      contract.buy_hours = val;
    //const index = this.data.actives_contracts.findIndex(contr => contr.id == contract.id);
    //this.data.actives_contracts[index].buy_hours = val;
    },
    validateHoursPurchase() {
      this.data.actives_contracts.forEach((contract, index) => {
        if (contract.buy_hours) {
          const buy_hours = Number(contract.buy_hours);

          if (isNaN(buy_hours)) {
            this.errors_purchase_hours.push(`${contract.vibbrante.name} - As horas deve ser um número inteiro`);
          } else if (buy_hours % 1 !== 0) {
            this.errors_purchase_hours.push(`${contract.vibbrante.name} - As horas deve ser um número inteiro`);
          }
        }
      });
    },
    buyHours() {
      this.validateHoursPurchase();

      if (this.errors_purchase_hours.length > 0) {
        this.errors_purchase_hours.forEach((error) => {
          this.$notify(error, "error");
        });
        return this.errors_purchase_hours = [];
      }

      clientApi
        .buyContractCredits(this.data.actives_contracts)
        .then(response => {
          if (response.status === 200) {
            clientApi
              .loadActivesContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadClientWaitingAnswerContracts',
                    response.data
                  );
                  this.$emit('refreshWallet');
                  this.action_success = true;
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    createContractComment() {
      if (this.data.comment_from === 'client') {
        clientApi
          .clientCreateContractComment(
            this.data.contract_id,
            this.contract_comment_description
          )
          .then(response => {
            if (response.status === 200) {
              this.contract_comment_description = '';
              this.question_ok = true;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        vibbranteApi
          .vibbranteCreateContractComment(
            this.data.contract_id,
            this.contract_comment_description
          )
          .then(response => {
            if (response.status === 200) {
              this.contract_comment_description = '';
              this.question_ok = true;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
    addHoursToContract() {
      clientApi
        .clientCreateContractAdditive(
          this.data.contract.id,
          this.contract_new_hours_balue
        )
        .then(response => {
          if (response.status === 200) {
            this.contract_new_hours_balue = 1;
            clientApi
              .clientGetContract(this.$route.params.id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadClientCurrentContract',
                    response.data
                  );
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/parts/modules/modals.vue